<script>
export default {
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
			// projectName: '卢德雷个人网站',
            projectName: 'Ludere独立游戏互助社区',
			author: 'Sherry',
		};
	},
};
</script>

<template>
	<div class="flex justify-center items-center text-center">
		<div
			class="font-general-regular text-lg text-ternary-dark dark:text-ternary-light"
		>
            &copy; {{ copyrightDate }}
            <a
				target="__blank"
				class="font-general-medium hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 duration-500"
			>
<!--				{{ projectName }}-->
<!--            Ludere-->
                Ludere
			</a>
            版权所有 |

			<a
                href="https://beian.miit.gov.cn/"
                rel="noopener"
                target="__blank"
				class="font-general-medium text-secondary-dark dark:text-secondary-light uppercase hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 duration-500"
				>苏ICP备2026021193号-1</a>
		</div>
	</div>
</template>

<style lang="scss" scoped></style>
